export default "__VITE_ASSET__6cff1865__"